<script setup lang="ts">
import Anchor from '~/components/ui/Anchor.vue'

const uiStore = useUIStore()
const { getLocalePrefix } = useSiteUrl()
const { offerCards } = useContentCardStore()
</script>

<template>
  <div class="login-modal">
    <Modal
      :show="uiStore.isShowLoginModal"
      clear-campaign-on-close
      @close="uiStore.isShowLoginModal = false"
      class="login-modal__modal"
      data-testid="login-modal"
    >
      <LoginForm />
      <div class="login-modal__my-offers">
        <h2 class="login-modal__my-offers-title">{{ $t('login_modal.my_offers.title') }}</h2>
        <p class="login-modal__my-offers-text">{{ $t('login_modal.my_offers.description') }}</p>
        <Anchor
          :url="`${getLocalePrefix()}/my-account/my-offers`"
          class="login-modal__my-offers-link"
          variant="secondary"
        >
          <span class="login-modal__my-offers-link-text">
            {{ $t('login_modal.my_offers.cta') }}

            <ContentNotifcation />
          </span>
          <span>({{ offerCards?.length }})</span>
        </Anchor>
      </div>
      <RegisteredInStoreCallout class="login-modal__registered-in-store" />
    </Modal>

    <Modal
      :show="uiStore.isShowForgotPasswordModal"
      @close="uiStore.isShowForgotPasswordModal = false"
      class="forgot-password-modal__modal"
      data-testid="forgot-password-modal"
    >
      <ForgotPassword @close="uiStore.isShowForgotPasswordModal = false" />
    </Modal>
  </div>
</template>

<style lang="postcss">
.login-modal {
  .login-modal__my-offers {
    margin-top: var(--space-90);
  }
  .login-modal__my-offers-title {
    margin-bottom: var(--space-50);
  }
  .login-modal__my-offers-text {
    margin-bottom: var(--space-60);
  }
  .login-modal__my-offers-link-text {
    margin-right: var(--space-20);
    position: relative;
    .content-card-notification {
      position: absolute;
      right: -0.313rem;
      top: -0.25rem;
    }
  }
  .login-modal__my-offers-link {
    width: 100%;
  }
  .login-modal__registered-in-store {
    margin-top: var(--space-100);
  }
}
</style>
